'use client'

import { createContext, type FC, type ReactNode, useMemo } from 'react'

import { type RegistrationFormState } from '../registrationFormMakeRegistrationFormState'

interface LoginRegistrationUserRegistrationFormState {
  registrationFormState: RegistrationFormState
}

export const LoginRegistrationRegistrationFormStateContext =
  createContext<LoginRegistrationUserRegistrationFormState>({
    registrationFormState: {} as RegistrationFormState,
  })

interface LoginRegistrationRegistrationFormProviderProps {
  children: ReactNode
  registrationFormState: RegistrationFormState
}

export const LoginRegistrationRegistrationFormStateProvider: FC<
  LoginRegistrationRegistrationFormProviderProps
> = ({ children, registrationFormState }) => {
  const value = useMemo(
    () => ({
      registrationFormState,
    }),
    [registrationFormState],
  )

  return (
    <LoginRegistrationRegistrationFormStateContext.Provider value={value}>
      {children}
    </LoginRegistrationRegistrationFormStateContext.Provider>
  )
}
